// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1Br4W","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__6HooO"};